import React from "react";
import "./Quytrinh.css";

const features = [
  {
    id: 1,
    icon: "/Q1.svg",
    title: "Bước 1: Liên hệ tư vấn",
    desc: "Chỉ cần nhắn Zalo hoặc gọi Hotline. Thông báo số tiền cần rút và yêu cầu nhân viên báo phí.",
  },
  {
    id: 2,
    icon: "/Q2.svg",
    title: "Xác nhận giao dịch và mức phí",
    desc: "Sau khi bạn đồng ý, chúng tôi mới tiến hành. Nhân viên thông báo rõ ràng cách giao dịch.",
  },
  {
    id: 3,
    icon: "/Q3.svg",
    title: "Bước 3: Thực hiện quẹt thẻ",
    desc: "Bạn tự thao tác như thanh toán mua sắm – thẻ luôn do bạn giữ, không qua tay người khác. An tâm tuyệt đối.",
  },
  {
    id: 4,
    icon: "/Q4.svg",
    title: "Bước 4: Nhận $ thần tốc trong 5 phút",
    desc: "Hoàn tất giao dịch là nhận $ ngay – $ mặt hoặc chuyển khoản. ",
  },
];

export default function Quytrinh() {
  return (
    <section className="why-choose">
      <div className="why-choose__container">
        <div className="why-choose__heading">
          <h2>Quy trình rút thẻ nhanh chóng</h2>
        </div>
        <div className="why-choose__grid">
          {features.map((item) => (
            <div className="why-choose__card" key={item.id}>
              <img
                src={item.icon}
                alt={item.title}
                className="why-choose__icon"
              />
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
        <div className="hero-cta-wrapper">
          <h4>Liên hệ tư vấn</h4>

          <div className="hero-cta-group">
            <a
              onClick={() => {
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                  event: "goi",
                });
              }}
              href="tel:0941297219"
            >
              Gọi 0941 297 219
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
